module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: _vm.className,
    style: (_vm.style)
  }, [_c('lumi-container', [_c('div', {
    staticClass: "lumi-section-inner"
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1c116607"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LumiSection.vue
// module id = 59
// module chunks = 0